import * as React from 'react';

// Material-UI
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';

interface RequestFormHelpDialogProps {
  handleClose: () => void;
  maxRequests: number;
  show: boolean;
}


const RequestFormHelpDialog: React.FC<RequestFormHelpDialogProps> = (props) => {

  return (
    <Dialog
      open={props.show}
      onClose={props.handleClose}
    >
      <DialogTitle>New Lodge Use Requests</DialogTitle>
      <DialogContent>
        <Typography variant="body2" gutterBottom>IMPORTANT: Lodge stays are limited to 14 days.</Typography>
        <Typography variant="button">Weekend/Holiday Requests & Limit</Typography>
        <Typography variant="body2" gutterBottom>Requests for up to {props.maxRequests} weekend/holidays can be active. When the limit is reached additional requests can be made for non-weekend/holidays only. An extended time period for the request could potentially span more than one weekend/holiday, e.g., two weekends. In this situation, each weekend/holiday counts towards the request limit.</Typography>
        <Typography variant="button">Non-Weekend/Non-Holiday Requests</Typography>
        <Typography variant="body2" gutterBottom>After the maximum weekend/holiday request limit has been reached, additional requests for non-weekend/non-holidays can be submitted which will not be counted towards the active weekend/holiday request limit.</Typography>
        <Typography variant="button">Post Deadline Request</Typography>
        <Typography variant="body2" gutterBottom>After the priority deadline, requests can be submitted for the upcoming weekend first come, first serve, which will not count towards the active request limit.</Typography>
        <Typography variant="button">Off-Season Request</Typography>
        <Typography variant="body2" gutterBottom>Off-season requests (5/1-11/30) can be made anytime during the year.</Typography>
        <Typography variant="button">Members</Typography>
        <Typography variant="body2" gutterBottom>By default all members in a household are selected for a new request. Deselect members if they are not to be included in the lodge use request. Members not included can be added later in My Requests. Individuals living in the household that are not members, juniors, or children need to be entered as guests.</Typography>
        <Typography variant="button">Guests</Typography>
        <Typography variant="body2" gutterBottom>Guests can be added to a request in My Requests after creatng the request.</Typography>
        <Typography variant="button">Notes</Typography>
        <Typography variant="body2" gutterBottom>Some uses for Notes are indicating a work weekend, specifying no dinner, ask for a ride, offer a ride, or any other information. Notes are visible to all members.</Typography>
        <Typography variant="button">Transferable Passes</Typography>
        <Typography variant="body2">A maximum of two (2) transferable passes per day can be requested. Lodge managers have priority use of passes during weekends/holidays. All other times are on a first come, first served basis.</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => props.handleClose()} color="primary">Close</Button>
      </DialogActions>
    </Dialog>
  );

}

export default RequestFormHelpDialog;